import { RichText, StickyBanner } from '@reward-platform/lift/components'
import { IconName } from '@reward-platform/lift/components/Icon/Icon.types'
import { useStickyBanner } from '~/hooks/useStickyBanner'
import { StickyBannerType } from '~/hooks/useStickyBanner/useStickyBanner'

const IconType: Record<StickyBannerType, IconName> = {
  ERROR: 'warning',
  INFO: 'info',
  SUCCESS: 'check-circle',
  WARNING: 'info',
  PROMOTION: 'gift',
}

export const StickyBanners = () => {
  const banners = useStickyBanner()
  return banners.map((banner) => (
    <StickyBanner
      variant={banner.type}
      key={banner.identifier}
      icon={IconType[banner?.type as StickyBannerType]}
      isClosable={banner.closable}
    >
      <RichText document={banner.message} />
    </StickyBanner>
  ))
}
